import { useAppSelector } from "stores";
import toCDNUrl, { isCDNUrl } from "modules/toCDNUrl";
import {
  getTurboRoomEnabled,
  getTurboRoom,
} from "stores/modules/entities.turboRooms/selectors";
import { useCallback } from "react";

export const useToCDNUrl = () => {
  const roomId = useAppSelector((state) => state.app.state.roomId);
  const turboEnabled = useAppSelector((state) =>
    roomId ? getTurboRoomEnabled(state, roomId) : false
  );
  const turboRoom = useAppSelector((state) =>
    roomId ? getTurboRoom(state, roomId) : null
  );
  const cdnUrl =
    turboEnabled && turboRoom?.cdnUrl ? turboRoom.cdnUrl : undefined;

  return useCallback(
    (baseUrl: string | null, options: { enableGoCdn?: boolean } = {}) => {
      return toCDNUrl(baseUrl, { enableGoCdn: false, ...options, cdnUrl });
    },
    [cdnUrl]
  );
};

export const useIsCDNUrl = () => {
  const roomId = useAppSelector((state) => state.app.state.roomId);
  const turboEnabled = useAppSelector((state) =>
    roomId ? getTurboRoomEnabled(state, roomId) : false
  );
  const turboRoom = useAppSelector((state) =>
    roomId ? getTurboRoom(state, roomId) : null
  );
  const cdnUrl =
    turboEnabled && turboRoom?.cdnUrl ? turboRoom.cdnUrl : undefined;

  return useCallback(
    (url: string) => {
      return isCDNUrl(url, { cdnUrl });
    },
    [cdnUrl]
  );
};
